// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1moBx","col":"styles_col__3bbWy"};